import { render, staticRenderFns } from "./DeleteRedirectModal.vue?vue&type=template&id=1e63f4ea&"
import script from "./DeleteRedirectModal.vue?vue&type=script&lang=js&"
export * from "./DeleteRedirectModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/atlassian/pipelines/agent/build/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1e63f4ea')) {
      api.createRecord('1e63f4ea', component.options)
    } else {
      api.reload('1e63f4ea', component.options)
    }
    module.hot.accept("./DeleteRedirectModal.vue?vue&type=template&id=1e63f4ea&", function () {
      api.rerender('1e63f4ea', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Services/Hosting/Shared/Domains/Redirects/DeleteRedirectModal.vue"
export default component.exports